import { render, staticRenderFns } from "./DepartamentosMarcaciones.vue?vue&type=template&id=55d8fd72&"
import script from "./DepartamentosMarcaciones.vue?vue&type=script&lang=js&"
export * from "./DepartamentosMarcaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports